(function() {
fd.home = {
    init: function() {
        $(".film-slider a").click(function() {
            try {
                var e = $(this),
                    href = e.attr("href"),
                    listings = href.replace(/^\/films\//, "/listings/"),
                    buttons = ["close"];
                
                if (e.data("listings")) {
                    buttons.push({
                        text: "Listings",
                        click: function() {
                            window.location = listings;
                        },
                        type: "primary"
                    });
                }
                
                buttons.push({
                    text: "More",
                    click: function() {
                        window.location = href;
                    },
                    type: "primary"
                });
                
                e
                    .next()
                    .css({
                        "max-height": $(window).height() - 190,
                        "max-width": $(window).width()
                    })
                    .dialog({
                        title: "Details",
                        buttons: buttons
                    }
                );
            }
            catch(ex) {
                alert(ex);
            }
            return false;
        });

        var showSliderBtns = function() {
            $(".film-slider-scroll-btn")
                .each(function() {
                    var btn = $(this),
                        slider = btn.closest(".film-slider"),
                        holder = slider.find(".film-holder"),
                        max = 0,
                        left = parseInt(holder.css("left"));

                    if (holder.width() < slider.width()) {
                        btn.addClass("disabled");
                    } else {
                        if (!btn.attr("class").match("left")) {
                            max = -(holder.width() - slider.width() - 10);
                        }

                        if (left == max) {
                            btn.addClass("disabled");
                        } else {
                            btn.removeClass("disabled");
                        }
                    }
                });
        };

        var slide = function(slider, direction) {
            var holder = slider.find(".film-holder"),
                width = slider.width(),
                max = -(holder.width() - width - 10),
                left = parseInt(holder.css("left"));

            if (direction < 0) {
                left = Math.min(left + width, 0);
            } else {
                left = Math.max(left - width, max);
            }

            holder.animate({left: left}, 500, function() {
                showSliderBtns();
            });
        }

        $(".film-slider")
            .css("overflow", "hidden")
            .append("<a href='#' class='fa fa-chevron-left bg-hover-orange-500 film-slider-scroll-btn disabled'></a>")
            .append("<a href='#' class='fa fa-chevron-right bg-hover-orange-500 film-slider-scroll-btn'></a>");

        if ("ontouchstart" in window || navigator.msMaxTouchPoints > 0) {
            $(".film-slider").on({
                touchstart: function(e) {
                    $(this).data("touchstart", e.originalEvent.changedTouches[0].clientX);
                },
                touchend: function(e) {
                    var distance = $(this).data("touchstart") - e.originalEvent.changedTouches[0].clientX;

                    if (Math.abs(distance) > 100) {
                        slide($(this), distance);

                        return false;
                    }
                }
            });
        }

        showSliderBtns();

        $(window).resize(function() {
            showSliderBtns();
        });

        $(".film-slider-scroll-btn").click(function() {
            slide($(this).closest(".film-slider"), $(this).attr("class").match("left") ? -1 : 1);

            return false;
        });
    }
};
})();
